<template>
    <div
        @dragenter="onDragEnter"
        @dragleave="onDragLeave"
        @drop.prevent="onDrop"
        @dragover="onDragOver"
        :style="[questionVideo ? {} : { width: width, height: height }]"
        :class="{ 'video-box': questionVideo }"
        class="upload-container"
    >
        <div
            :style="`pointer-events: none; ${previewImageStyle}`"
            class="position-absolute w-100 h-100 overflow-hidden"
        >
            <img v-if="path" :src="path" class="img-fluid img-bg" :class="{ 'bg-filter': background }" />
        </div>
        <Loader v-if="isLoading"></Loader>
        <label class="cursor-pointer" @click="isShowModal = true">
            <!-- <input @change="onUploadImageHandler" accept="image/*" class="hidden" type="file"> -->
            <p v-if="!path" class="text-placeholder text-center mb-0 text-muted">{{ message }}</p>
        </label>

        <VideoPlayer
            v-if="videoMeta.video"
            :video-meta="videoMeta"
            :video-path="videoMeta.video"
            :timeDuration="videoMeta.duration"
            class="w-100 h-100 position-absolute"
            id="player"
        ></VideoPlayer>

        <a v-if="path" @click="onRemoveImageHandler" class="close cursor-pointer">
            <XIcon size="1x" class="text-white"></XIcon>
        </a>

        <a
            v-if="!disableCrop && (path || videoPath) && !hideEditCropButton && !isGif"
            v-tippy="{ placement: 'top-center', arrow: true, arrowType: 'round', animation: 'fade' }"
            @click.prevent="questionVideo ? handleEditVideo() : handleEditImage()"
            :content="questionVideo ? 'Edit video' : 'Edit crop'"
            :style="[questionVideo ? { right: '10px', bottom: '190px' } : {}]"
            class="position-absolute tool-icon source-edit"
            target="_blank"
            href="#"
        >
            <i class="fas fa-pen"></i>
        </a>

        <UploadImageModal
            ref="openAsUpload"
            v-if="isShowModal"
            @close="isShowModal = false"
            @setImage="onUploadImageHandler"
            @setVideo="onUploadVideoHandler"
            @setVideoTime="handleUpdateVideoTime"
            @setVideoMute="handleUpdateVideoMute"
            @setVideoLoop="handleUpdateVideoLoop"
            @select-ai="showAIGenerateImageModal = true"
            @close-ai="showAIGenerateImageModal = false"
            :question-video="questionVideo"
            :keep-ratio-crop-area="keepRatioCropArea"
            :disable-crop="disableCrop"
            :show-giphy="showGiphy"
            :show-youtube-upload="showYoutubeUpload"
            :video-limit-time="videoLimitTime"
        >
        </UploadImageModal>

        <AIGenerateImageModal
            v-if="showAIGenerateImageModal"
            @image-selected="imageAISelected"
            @close="showAIGenerateImageModal = false"
            :title="promptTitle"
            :location="location"
        />

        <QuizGenerateBgModal
            v-if="showGenerateBgModal"
            @image-selected="$emit('onCropBackground', $event)"
            @close="showGenerateBgModal = false"
            :image="path"
            ref="genBgModal"
        />
    </div>
</template>

<script>
import Loader from '@/components/Loader'
import dragDropUpload from '@/service/drag-drop-upload'
import upload from '@/service/upload'
import axios from 'axios'
import API_URL from '@/router/api'
import { XIcon } from 'vue-feather-icons'
import UploadImageModal from '../../../frontend/src/components/UploadImageModal.vue'
import VideoPlayer from '../../../frontend/src/components/VideoPlayer.vue'
import AIGenerateImageModal from '../../../frontend/src/components/AIGenerateImageModal.vue'
import QuizGenerateBgModal from '../../../frontend/src/components/quiz-creator/QuizGenerateBgModal.vue'

export default {
    name: 'upload-picker',

    components: {
        Loader,
        XIcon,
        UploadImageModal,
        VideoPlayer,
        AIGenerateImageModal,
        QuizGenerateBgModal
    },

    props: {
        width: {
            type: String,
            default: '200px'
        },
        height: {
            type: String,
            default: '200px'
        },
        path: {
            type: String,
            default: ''
        },
        imageOriginal: {
            type: String,
            default: ''
        },
        imageSource: {
            type: String,
            default: ''
        },
        imageCoordinates: {
            type: [Object, Array, String]
        },
        background: {
            type: Boolean,
            default: false
        },
        videoPath: {
            type: String,
            default: ''
        },
        videoTime: {
            type: Array
        },
        videoMute: {
            type: Boolean,
            default: false
        },
        videoLoop: {
            type: Boolean,
            default: false
        },
        videoProvider: {
            type: String,
            default: 'mp4'
        },
        videoLimitTime: {
            type: [Number, String],
            default: 15
        },
        message: {
            type: String,
            default: 'Drop file here or click to upload.'
        },
        index: {
            type: String,
            default: ''
        },
        quizName: {
            type: String,
            required: true
        },
        questionVideo: {
            type: Boolean,
            default: false
        },
        keepRatioCropArea: {
            type: Boolean,
            default: false
        },
        hideEditCropButton: {
            type: Boolean,
            default: false
        },

        questionType: {
            type: String,
            default: null
        },
        disableCrop: {
            type: Boolean,
            default: false
        },
        previewImageStyle: {
            type: String || Object,
            default: ''
        },
        showGiphy: {
            type: Boolean,
            default: true
        },
        showYoutubeUpload: {
            type: Boolean,
            default: true
        },

        promptTitle: {
            type: String,
            default: ''
        },

        location: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            isLoading: false,
            isShowModal: false,
            videoMeta: {
                video: null,
                thumbnail: null,
                duration: null
            },
            videoTimeDuration: '',
            mockFile: null,
            showAIGenerateImageModal: false,
            showGenerateBgModal: false
        }
    },

    watch: {
        'videoMeta.video'() {
            if (this.videoMeta.video && this.videoMeta.thumbnail) {
                this.isLoading = false
            }
        },

        videoPath(val) {
            if (!val) {
                this.videoMeta = {
                    video: null,
                    thumbnail: null,
                    duration: null
                }
            }
        }
    },

    computed: {
        isGif() {
            return this.path.indexOf('.gif') > -1
        }
    },

    mounted() {
        if (this.videoPath) {
            this.videoMeta = {
                video: this.videoPath,
                thumbnail: this.path,
                duration: this.videoTime
                // provider: "mp4"
            }
        }
    },

    methods: {
        ...dragDropUpload.init(),

        onDrop: async function (event) {
            dragDropUpload.onDrop(event)

            let dataTransfer = event.dataTransfer,
                files = dataTransfer.files

            if (!files.length) {
                return false
            }

            let fileObject = {
                target: {
                    files: [files[0]]
                }
            }

            // if(this.questionVideo) {
            //     this.dropVideo(fileObject)
            // } else {
            //     this.$refs.openAsUpload.selectImage(files[0])
            //     // this.uploadImage(files[0])
            // }

            let validateFileSuccess = function () {
                this.isShowModal = true

                // if (typeof answerIndex !== 'undefined') {
                //     this.$refs.addData.setLocation('answer')
                //     this.$refs.addData.setAnswerIndex(answerIndex)
                // } else {
                //     this.$refs.addData.setLocation('question')
                //     this.$refs.addData.setQuestionIndex(index)
                // }

                this.$nextTick(() => {
                    if (this.questionVideo) {
                        this.$refs.openAsUpload.getVideo(fileObject)
                    } else {
                        if (this.background) {
                            this.$refs.openAsUpload.setLocation('background')
                        }
                        this.$refs.openAsUpload.selectImage(fileObject)
                    }
                })
            }.bind(this)

            let validateFileFail = function () {
                files = null
            }

            if (this.questionVideo) {
                upload.addFile(fileObject.target.files[0]).validateVideo(validateFileSuccess, validateFileFail)
            } else {
                upload.addFile(fileObject.target.files[0]).validate(validateFileSuccess, validateFileFail)
            }
        },

        onUploadImageHandler: function (e, questionIndex, answerIndex, ai) {
            if (!e.target.files.length) {
                return false
            }

            this.mockFile = e.target.files[1] || false

            let file = e.target.files[0],
                afterUploadQuizImage = function () {
                    e.target.value = ''
                }

            this.uploadImage(file, afterUploadQuizImage, afterUploadQuizImage, ai)
        },

        onUploadVideoHandler: function (e, videoTimeDuration, videoMute, videoLoop) {
            if (e === undefined) {
                return false
            }

            let file = {
                    target: {
                        files: [e]
                    }
                },
                afterUploadQuizVideo = function () {
                    file.target.value = ''
                }

            this.uploadVideo(
                file.target.files[0],
                videoTimeDuration,
                videoMute,
                videoLoop,
                afterUploadQuizVideo,
                afterUploadQuizVideo
            )
        },

        uploadImage: function (file, successCallback, failCallback, ai) {
            let validateFileSuccess = async function () {
                this.isLoading = true

                let imagePath = '',
                    originalImagePath = '',
                    imageSourcePath = '',
                    coordinates = {}

                let imageData = new FormData()

                const pixelFile = this.mockFile

                if (file.image_original) {
                    imageData.append('image_original', file.image_original)
                }

                const tempFile = file

                // Hack
                if (file.name === 'image.gif' && pixelFile) {
                    file = pixelFile
                }

                imageData.append('image', file)

                const params = {
                    question_type: this.questionType || ''
                }

                let url = new URLSearchParams(params)

                for (const item in params) {
                    if (params[item]) {
                        url.set(item, params[item])
                    }
                }

                url = url.toString() ? `${API_URL.upload}?${url.toString()}` : API_URL.upload

                //image form
                let getImagePath = await axios
                    .post(url, imageData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .catch(error => {
                        this.isLoading = false
                        window.shout.error(`Upload Image Failed ! <br/> ${error.response.data.message}`)
                    })

                file = tempFile

                originalImagePath = file.image_original

                if (getImagePath.status === 200) {
                    imagePath = getImagePath.data.data.upload_path
                    coordinates = file.coordinates
                    if (file.external === true) {
                        //external image
                        originalImagePath = file.image_original
                        imageSourcePath = file.source
                    } else if (this.questionVideo) {
                        //internal video
                        this.videoMeta.img_url = imagePath
                        originalImagePath = ''
                    } else if (file.image_original && typeof file.image_original !== 'string') {
                        let originalImageData = new FormData()
                        originalImageData.append('image', file.image_original[0])

                        //original image form
                        let getOriginalPath = await axios
                            .post(API_URL.upload, originalImageData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })
                            .catch(error => {
                                this.isLoading = false
                                window.shout.error(`Upload Image Failed ! <br/> ${error.response.data.message}`)
                            })

                        if (getOriginalPath.status === 200) {
                            originalImagePath = getOriginalPath.data.data.upload_path
                        } else {
                            this.isLoading = false
                            window.shout.error('Upload Original Image Failed !')
                        }
                    }

                    this.$nextTick(() => {
                        if (this.index != '') {
                            this.$emit('onUploadImageHandler', {
                                img: imagePath,
                                originalImage: originalImagePath,
                                imageSource: imageSourcePath,
                                coordinates: coordinates,
                                answerIndex: this.index
                            })
                        } else {
                            this.$emit(
                                'onUploadImageHandler',
                                imagePath,
                                originalImagePath,
                                imageSourcePath,
                                coordinates
                            )

                            if (ai && process.env.VUE_APP_GENERATE_BACKGROUND === 'true') {
                                const self = this

                                this.$vueConfirm.confirm(
                                    {
                                        message: 'Do you want to generate a new background with AI?',
                                        button: {
                                            no: 'No',
                                            yes: 'Yes'
                                        }
                                    },
                                    async function (confirm) {
                                        if (confirm) {
                                            self.showGenerateBgModal = true

                                            await self.$nextTick()

                                            self.$refs.genBgModal.genBgBackend()
                                        }
                                    }
                                )
                            }
                        }

                        this.isLoading = false
                    })
                } else {
                    this.isLoading = false
                    window.shout.error('Upload Image Failed !')
                }
            }.bind(this)

            let validateFileFail = () => {
                if (typeof failCallback == 'function') {
                    failCallback()
                }
                this.isLoading = false
            }

            if (file.external === true && this.questionVideo === true) {
                if (this.index != '') {
                    this.$emit('onUploadImageHandler', {
                        img: file.img_url,
                        originalImage: '',
                        imageSource: '',
                        coordinates: {},
                        answerIndex: this.index
                    })
                } else {
                    this.$emit('onUploadImageHandler', file.img_url, '', '', {})
                }
            } else {
                upload.addFile(file).validate(validateFileSuccess, validateFileFail)
            }
        },

        handleEditImage(name) {
            const imageName = this.path.split('?')[0].split('/').pop()
            const imageObject = {
                img_url: this.imageOriginal,
                image_original: this.imageOriginal,
                source: this.imageSource,
                coordinates: this.imageCoordinates,
                image_name: imageName
            }

            name != 'background' ? (this.isShowModal = true) : (this.isShowBgModal = true)

            this.$nextTick(() => {
                this.$refs.openAsUpload.editImage(imageObject)
            })
        },

        uploadVideo: function (file, videoTimeDuration, videoMute, videoLoop, successCallback, failCallback) {
            if (file.target !== undefined) {
                if (!file.target.files.length) {
                    return false
                } else {
                    file = file.target.files[0]
                }
            }

            let validateFileSuccess = function () {
                this.isLoading = true

                let formData = new FormData()
                formData.append('image', file)

                // video form
                axios
                    .post(API_URL.upload, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(res => {
                        const videoPath = res.data.data.upload_path
                        if (this.index != '') {
                            this.$emit('onUploadVideoHandler', {
                                video: videoPath,
                                videoTimeDuration: videoTimeDuration,
                                videoMute: videoMute,
                                videoLoop: videoLoop,
                                index: this.index
                            })
                        } else {
                            this.$emit('onUploadVideoHandler', videoPath, videoTimeDuration, videoMute, videoLoop)
                        }

                        this.videoMeta.video = videoPath
                        this.videoMeta.duration = videoTimeDuration
                    })
                    .catch(error => {
                        setTimeout(() => {
                            this.onRemoveImageHandler()
                        }, 300)
                        window.shout.error(`Upload Video Failed ! <br/> ${error.response.data.message}`)
                    })

                if (typeof successCallback == 'function') {
                    successCallback()
                }
            }.bind(this)

            let validateFileFail = function () {
                if (typeof failCallback == 'function') {
                    failCallback()
                }
            }

            if (file.external) {
                if (this.index != '') {
                    this.$emit('onUploadVideoHandler', {
                        video: file.video,
                        videoTimeDuration: videoTimeDuration,
                        videoMute: videoMute,
                        videoLoop: videoLoop,
                        index: this.index
                    })
                } else {
                    this.$emit('onUploadVideoHandler', file.video, videoTimeDuration, videoMute, videoLoop)
                }

                this.videoMeta.provider = file.provider
                this.videoMeta.video = file.video
                this.videoMeta.duration = videoTimeDuration
            } else {
                upload.addFile(file).validateVideo(validateFileSuccess, validateFileFail)
            }
        },

        handleEditVideo() {
            let videoObject = {
                video: this.videoPath,
                video_time: this.videoTime,
                video_mute: this.videoMute,
                video_loop: this.videoLoop,
                video_provider: this.videoProvider
            }
            this.isShowModal = true
            this.$nextTick(() => {
                this.$refs.openAsUpload.editVideo(videoObject)
            })
        },

        handleUpdateVideoTime(videoTime) {
            this.$emit('onUpdateVideoTime', videoTime)
            this.videoMeta.duration = videoTime
        },

        handleUpdateVideoMute(videoMute) {
            this.$emit('onUpdateVideoMute', videoMute)
            this.videoMeta.mute = videoMute
        },

        handleUpdateVideoLoop(videoLoop) {
            this.$emit('onUpdateVideoLoop', videoLoop)
            this.videoMeta.mute = videoLoop
        },

        dropVideo(event) {
            let v = this
            if (event.target.files.length > 0) {
                let myFile = event.target.files[0]
                let sizeLimit = 5000000 //process.env.VUE_APP_ALLOWED_UPLOAD_VIDEO_SIZE
                if (myFile.type === 'video/mp4' || myFile.type === 'video/quicktime') {
                    if (myFile.size <= sizeLimit) {
                        //check video size <= size limit
                        let videoElement = document.createElement('video')
                        let fileURL = URL.createObjectURL(myFile)
                        videoElement.src = fileURL
                        videoElement.ondurationchange = async function () {
                            let videoDuration = this.duration
                            let durationLimit = 15
                            if (videoDuration <= durationLimit) {
                                //check video duration <= duration limit
                                v.isLoading = true
                                let videoThumbnail = await v.getVideoThumbnail(myFile)
                                await v.uploadVideo(myFile)
                                await v.uploadImage(videoThumbnail.target.files[0])
                            } else {
                                event.target.value = ''
                                window.shout.error('File duration too much')
                                return false
                            }
                        }
                    } else {
                        event.target.value = ''
                        window.shout.error('File size too large')
                        return false
                    }
                } else {
                    event.target.value = ''
                    window.shout.error('Please upload only MP4 file')
                    return false
                }
            } else {
                return
            }
        },

        async getVideoThumbnail(myFile) {
            let videoElement = document.createElement('video')
            let fileURL = URL.createObjectURL(myFile)
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            let custom
            videoElement.src = fileURL
            await new Promise(resolve => {
                videoElement.addEventListener('loadedmetadata', () => {
                    videoElement.width = videoElement.videoWidth
                    videoElement.height = videoElement.videoHeight
                    canvas.width = videoElement.width
                    canvas.height = videoElement.height
                    // Seek the video to 25%
                    videoElement.currentTime = videoElement.duration * 0.25
                })
                videoElement.addEventListener('seeked', () => resolve())
            })
            ctx.drawImage(videoElement, 0, 0, videoElement.width, videoElement.height)
            return new Promise(resolve => {
                canvas.toBlob(function (blob) {
                    blob.name = 'image.jpeg'
                    blob.lastModified = new Date()
                    const myFile = new File([blob], 'image.jpeg', {
                        type: blob.type
                    })
                    custom = {
                        target: {
                            files: [myFile]
                        }
                    }

                    resolve(custom)
                }, 'image/jpeg')
            })
        },

        onRemoveImageHandler: function () {
            if (this.index != '') {
                this.$emit('onRemoveImageHandler', this.index)
                this.$emit('onRemoveVideoHandler', this.index)
            } else {
                this.$emit('onRemoveImageHandler', '')
                this.$emit('onRemoveVideoHandler', '')
            }
            this.videoMeta.video = null
            this.videoMeta.thumbnail = null
        },

        popup() {
            let popup

            try {
                popup = require('@/lib/popup.js').default
            } catch {
                if (typeof window.shout != 'undefined') {
                    popup = window.shout
                    popup.alert = popup.error
                }
            }

            return popup
        },

        imageAISelected(url) {
            url = url.replace(':8001', '')

            //hack create dom
            const dom = document.createElement('div')
            dom.setAttribute('data-img', url)
            dom.setAttribute('data-source', url)
            dom.setAttribute('data-thumbnail', url)

            const obj = {
                target: dom
            }

            this.$refs.openAsUpload.selectExternalImage(obj)
        }
    }
}
</script>

<style lang="scss">
:root {
    --bg-image-blur: blur(0px);
    --bg-image-brightness: brightness(100%);
    --bg-image-opacity: 100%;
}

.upload-container {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border: 2px dashed #ccc;
    border-radius: 0.75rem;
    overflow: hidden;
    position: relative;

    label {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        margin-bottom: 0;
    }

    .close {
        position: absolute;
        top: 5px;
        right: 5px;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 1;
        border-radius: 50%;
        // padding: 0.25rem;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .hidden {
        position: absolute;
        // top: -9999px;
        // left: -9999px;
        opacity: 0;
        pointer-events: none;
    }
    .img-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        object-fit: cover;

        &.bg-filter {
            filter: var(--bg-image-blur);
            opacity: var(--bg-image-opacity);
        }
    }

    #player {
        top: 0;
        left: 0;
    }

    .tool-icon {
        &.source-edit {
            bottom: 5px;
            right: 5px;
        }
    }
}

.video-box {
    min-width: 450px;
    height: 16rem;
}

@media screen and (max-width: 767px) {
    .question-type-text {
        font-size: 12px;
    }
}

@media screen and (max-width: 500px) {
    .video-box {
        min-width: unset;
        width: 100%;
        height: auto;
    }
}

.upload-ai-btn {
    height: auto !important;
}

.prompt-panel {
    textarea {
        &#prompt-text {
            text-align: center;
            padding: 0.8rem;
            font-weight: bold;
        }
    }
}
#ai-generate-image-modal .modal-backdrop .modal-content #button-generate-img {
    padding: 0 16px;
    height: 42px;
    border-radius: 4px;
    border: none;
    background-color: #000;
    color: #fff;
}

#ai-generate-image-modal .modal-backdrop .modal-content #button-choose-img {
    padding: 0 16px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid #000;
    background-color: transparent;
    color: #000;
}

.theme-dark-mode {
    #ai-generate-image-modal .modal-backdrop .modal-content #button-choose-img {
        color: #fff;
        border-color: #fff;
    }
}
</style>
